import React, { useState } from "react";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import DateRangeFilter from "components/DateRangeFilter/DateRangeFilter";
import AsmDp from "./AsmDp.jsx";
import { getCurrentDate, getFirstDayOfMonth } from "../../Utils/dateUtils.js";
import { useDateFilter } from "Hooks/useDateFilter.js";
import { SCREEN_KEYS } from "constants/screenKeys.js";

function ASM() {

  const { fromDate, toDate, setFromDate, setToDate } = useDateFilter(
     SCREEN_KEYS.ASM_REPORT,
     { fromDate: getFirstDayOfMonth(), toDate: getCurrentDate() }
   );
 
   const handleFromDateChange = (value) => {
    setFromDate(value);
    if (value > toDate) setToDate(value);
  };

  const handleToDateChange = (value) => {
    if (value < fromDate) return;
    setToDate(value);
  };
  

  return (
    <Box minH="100vh" bg="gray.50" pt={{ base: "10vh", md: "13vh" }}>
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align={{ base: "flex-start", md: "center" }}
        gap={4}
        mb={8}
        px={6}
      >
        <Box>
          <Heading size="lg" color="gray.800" mb={2}>
            ASM (Area Sales Manager) - Coca-Cola
          </Heading>
          <Text color="gray.500">
            Drill into ASM execution metrics and territory trends
          </Text>
        </Box>
        <DateRangeFilter
          fromDate={fromDate}
          toDate={toDate}
          onFromDateChange={handleFromDateChange}
          onToDateChange={handleToDateChange}
        />
      </Flex>
      <AsmDp
        fromDate={fromDate}
        toDate={toDate}
      />
    </Box>
  );
}

export default ASM;